import React, { useState } from "react";
import { LogOut, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const handleLogoutClick = () => {
    setShowModal(true);
  };

  const handleConfirmLogout = () => {
    setShowModal(false);

    const isAdminRoute = location.pathname.includes("admin");

    if (isAdminRoute) {
      navigate("/admin/login");
    } else {
      navigate("/login"); 
    }
  };

  const handleCancelLogout = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="p-4 border-t border-gray-200 mt-auto bg-white">
        <button
          className="flex items-center w-full hover:bg-gray-100 p-3 rounded-lg transition-colors text-gray-700"
          onClick={handleLogoutClick}
        >
          <div className="p-1.5 mr-3 rounded-full bg-gradient-to-r from-red-400 to-pink-500">
            <LogOut size={16} className="text-white" />
          </div>
          <span>Logout</span>
        </button>
      </div>

      {/* Modal Overlay */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          {/* Modal Content */}
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 transform transition-all">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900">
                Confirm Logout
              </h3>
              <button
                onClick={handleCancelLogout}
                className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
              >
                <X size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="p-3 rounded-full bg-red-100 mr-4">
                  <LogOut size={24} className="text-red-600" />
                </div>
                <div>
                  <p className="text-gray-800 font-medium">
                    Are you sure you want to logout?
                  </p>
                  <p className="text-gray-500 text-sm mt-1">
                    You'll need to sign in again to access your account.
                  </p>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex gap-3 p-6 pt-0">
              <button
                onClick={handleCancelLogout}
                className="flex-1 px-4 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLogout}
                className="flex-1 px-4 py-2.5 text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 rounded-lg font-medium transition-all shadow-sm hover:shadow-md"
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Logout;
